import { useMutation, useQuery } from '@apollo/client'
import deleteVenueDevice from 'graphQL/venue/deleteVenueDevice'
import listVenueDevicesByEmail from 'graphQL/venue/listVenueDevices'
import registerOrUpdateVenueDevice from 'graphQL/venue/registerOrUpdateVenueDevice'
import updateVenueDevice from 'graphQL/venue/updateVenueDevice'

export const useRegisterVenueDevice = (options) => {
  return useMutation(registerOrUpdateVenueDevice, options)
}

export const useUpdateVenueDevice = (options) => {
  return useMutation(updateVenueDevice, options)
}

export const useListVenueDevices = (options) => {
  return useQuery(listVenueDevicesByEmail, options)
}

export const useDeleteVenueDevices = (options) => {
  return useMutation(deleteVenueDevice, options)
}
